export default __webpack_public_path__ + "static/media/logo-blue.6d249893.svg";